export const environment = {
    local       : false,
    production  : false,
    hmr         : false,

    appName: `IFB [[ TESTING ]]`,

    wsPort:     2000,
    wsHost:     '',
    wsAppId:     "",
    apiHost:     'https://apipcp.umobi.com.br',
    baseUrl:     'https://apipcp.umobi.com.br',
    apiUrl:     'https://apipcp.umobi.com.br/api',
    storageUrl:  'https://apipcp.umobi.com.br/storage',
    googleMapsKey: 'AIzaSyDKay9VAjmvGXNNcNQt5oCNyrExq9z2Qc8',
    
};